// Open retention for one project on the Dashboard P&L card "Retention Held"
// (useDashboardPnl.ts, ProjectPnlSummary.retention).
//
// Open retention is the retention held back on the project's progress claims
// (claims_reports.retention_amount) minus the retention already received back
// (claims_reports.retention_received_amount). Before this, the card added up
// the held amount only, so retention paid back still showed as held.
//
// The arithmetic is exact: when more has been received than was held, the
// result is negative and stays negative, so the card shows it rather than
// hiding it.
//
// Only the per-project summary is net. The per-month P&L results keep the held
// amount, because they feed the shared P&L calculation (pnlCalculationCore.ts)
// and the Pareto chart's own re-aggregation, which carry it but never show it.
//
// Pure TypeScript, no React or supabase import, so dashboardPnlRetention.test.ts
// can pin it with Deno.

export interface RetentionReportInput {
  retention_amount?: number | string | null;
  retention_received_amount?: number | string | null;
}

/** Retention held minus retention received, summed over a project's claim reports. */
export function openRetention(reports: RetentionReportInput[]): number {
  let held = 0;
  let received = 0;
  for (const r of reports) {
    held += Number(r.retention_amount) || 0;
    received += Number(r.retention_received_amount) || 0;
  }
  return held - received;
}
